import { defineComponent, createVNode, TransitionGroup } from "vue";
import CascaderOption from "./cascader-option.js";
import { getPrefixCls } from "../_utils/global-config.js";
import Empty from "../empty/index.js";
var CascaderPanel = defineComponent({
  name: "CascaderPanel",
  props: {
    displayColumns: {
      type: Array,
      required: true
    },
    selectedPath: {
      type: Array,
      required: true
    },
    activeNode: {
      type: Object
    },
    computedKeys: {
      type: Array,
      required: true
    },
    expandTrigger: String,
    multiple: Boolean,
    totalLevel: {
      type: Number,
      required: true
    }
  },
  emits: ["clickOption", "activeChange", "pathChange"],
  setup(props, {
    emit
  }) {
    const prefixCls = getPrefixCls("cascader");
    const renderEmpty = () => {
      return createVNode(Empty, null, null);
    };
    const renderColumn = (column, level = 0) => {
      return createVNode("div", {
        "class": `${prefixCls}-panel-column`,
        "key": `column-${level}`,
        "style": {
          zIndex: props.totalLevel - level
        }
      }, [column.length === 0 ? createVNode("div", {
        "class": `${prefixCls}-list-empty`
      }, [renderEmpty()]) : createVNode("ul", {
        "class": [`${prefixCls}-list`, {
          [`${prefixCls}-list-multiple`]: Boolean(props == null ? void 0 : props.multiple)
        }]
      }, [column.map((item) => {
        var _a;
        return createVNode(CascaderOption, {
          "key": item.key,
          "option": item,
          "computedKeys": props.computedKeys,
          "isActive": props.selectedPath.includes(item) || item.key === ((_a = props.activeNode) == null ? void 0 : _a.key),
          "multiple": props.multiple,
          "expandTrigger": props.expandTrigger,
          "onClickOption": (option, checked) => emit("clickOption", option, checked),
          "onActiveChange": (option) => emit("activeChange", option),
          "onPathChange": (option) => emit("pathChange", option)
        }, null);
      })])]);
    };
    return () => createVNode(TransitionGroup, {
      "tag": "div",
      "name": "cascader-slide",
      "class": `${prefixCls}-panel`
    }, {
      default: () => [props.displayColumns.length > 0 ? props.displayColumns.map((column, index) => renderColumn(column, index)) : renderEmpty()]
    });
  }
});
export { CascaderPanel as default };
